var map = {
	"./autherium.png": 4236,
	"./binance.png": 3380,
	"./coinbase.png": 7687,
	"./formatic.png": 6064,
	"./metamax.png": 9088,
	"./nft-1.jpg": 3220,
	"./nft-2.gif": 7780,
	"./nft-3.gif": 2878,
	"./nft-4.jpg": 2292,
	"./nft-top-2-cat.png": 1148,
	"./nft-top-img.png": 1404,
	"./portise.png": 6912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9691;